import { Stack, StackProps } from '@chakra-ui/react';
import { useIsoStates } from '@pelicargo/ui';
import { COUNTRIES } from '@pelicargo/utils';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import { SimpleInput } from '../SimpleInput';
import { SimpleReactSelect } from '../SimpleReactSelect';

type Props = StackProps & {
  name?: string;
  handleAddressChange?: () => void;
};

export const AddressForm = ({ name, handleAddressChange, ...props }: Props) => {
  const getFieldName = useCallback((field: string) => (name ? `${name}.${field}` : field), [name]);
  const { control } = useFormContext();

  const states = useIsoStates(control, getFieldName('country'));

  return (
    <Stack {...props}>
      <SimpleInput
        name={getFieldName('recipient')}
        label="Business name or recipient"
        variant="outline"
        onBlur={handleAddressChange}
      />
      <SimpleInput
        name={getFieldName('line_one')}
        label="Street Address *"
        variant="outline"
        onBlur={handleAddressChange}
      />
      <SimpleInput
        name={getFieldName('line_two')}
        label="Apartment/Suite/Other"
        variant="outline"
        onBlur={handleAddressChange}
      />
      <SimpleReactSelect
        name={getFieldName('country')}
        label="Country *"
        variant="outline"
        options={COUNTRIES.map((country) => ({
          label: country?.name,
          value: country?.code,
        }))}
        simpleFieldProps={{
          w: 'full',
        }}
      />
      <SimpleReactSelect
        name={getFieldName('state')}
        label="State *"
        variant="outline"
        options={states}
        simpleFieldProps={{
          w: 'full',
        }}
      />
      <Stack direction={{ base: 'column', sm: 'row' }} spacing="4" w="full">
        <SimpleInput name={getFieldName('city')} label="City *" variant="outline" onBlur={handleAddressChange} />
        <SimpleInput
          name={getFieldName('zip_code')}
          label="Zip/Postal Code *"
          variant="outline"
          onBlur={handleAddressChange}
        />
      </Stack>
    </Stack>
  );
};
